import { SVGProps } from "types";

const IllustrationDevices = (props: SVGProps) => {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2042_6647)">
        <path
          d="M83.0103 29.4478C77.0041 23.2692 67.6309 22.4169 60.6956 26.8906C58.7225 28.1633 56.3332 28.5901 54.0411 28.0812C48.6159 26.8765 42.9407 27.6993 38.1071 30.3228C34.8574 32.0864 30.8993 31.7798 27.8669 29.6645C25.8539 28.2604 23.5164 27.2543 20.9478 26.781C11.4194 25.0249 2.15547 31.3447 0.323798 40.8587C-1.54947 50.5884 4.90049 59.9389 14.6231 61.6709C16.9986 62.094 19.3476 62.0227 21.5648 61.5306C25.1632 60.7321 28.9228 62.0672 31.245 64.9296C32.7107 66.7364 34.4783 68.3489 36.5313 69.6887C47.1414 76.6118 61.3547 73.6229 68.2779 63.0131C68.2852 63.0019 68.2925 62.9905 68.2999 62.9794C69.5678 61.0288 71.5399 59.6381 73.8205 59.1777C77.1468 58.5061 80.3175 56.8738 82.8879 54.2801C89.6552 47.4511 89.7115 36.3413 83.0103 29.4478Z"
          fill="url(#paint0_linear_2042_6647)"
        />
        <path
          opacity="0.1"
          d="M82.6719 56.6524V44.3821C82.6719 43.4326 81.9022 42.6628 80.9526 42.6628H72.5285V23.8855C72.5285 22.4613 71.3738 21.3066 69.9497 21.3066H22.9986C21.5744 21.3066 20.4198 22.4611 20.4198 23.8855V37.5052H7.04739C6.09795 37.5052 5.32812 38.2748 5.32812 39.2244V56.6524H82.6719Z"
          fill="#2626BC"
        />
        <path
          d="M54.2112 73.0914H38.7373L40.7637 65.0648L41.8328 60.8281H51.1157L52.1848 65.0648L54.2112 73.0914Z"
          fill="#9FB0FE"
        />
        <path
          d="M52.1848 65.0648H40.7637L41.8327 60.8281H51.1157L52.1848 65.0648Z"
          fill="#8399FE"
        />
        <path
          d="M69.9498 63.1747H22.9987C21.5746 63.1747 20.4199 62.0202 20.4199 60.5959V26.9792C20.4199 25.555 21.5744 24.4004 22.9987 24.4004H69.9498C71.374 24.4004 72.5286 25.5549 72.5286 26.9792V60.5959C72.5286 62.02 71.374 63.1747 69.9498 63.1747Z"
          fill="white"
        />
        <path
          d="M65.4666 43.9128H27.4822C27.1974 43.9128 26.9666 43.682 26.9666 43.3972V30.9717H65.9822V43.3974C65.9822 43.682 65.7514 43.9128 65.4666 43.9128Z"
          fill="#FFA8CF"
        />
        <path
          d="M50.1272 47.9336H31.8191C31.3444 47.9336 30.9597 47.5488 30.9597 47.0742C30.9597 46.5997 31.3444 46.2148 31.8191 46.2148H50.1272C50.6019 46.2148 50.9866 46.5997 50.9866 47.0742C50.9866 47.5488 50.6018 47.9336 50.1272 47.9336Z"
          fill="#B7C5FF"
        />
        <path
          d="M50.1272 51.3711H31.8191C31.3444 51.3711 30.9597 50.9863 30.9597 50.5117C30.9597 50.0372 31.3444 49.6523 31.8191 49.6523H50.1272C50.6019 49.6523 50.9866 50.0372 50.9866 50.5117C50.9866 50.9863 50.6018 51.3711 50.1272 51.3711Z"
          fill="#B7C5FF"
        />
        <path
          d="M59.2366 51.3711H56.3972C55.9225 51.3711 55.5378 50.9863 55.5378 50.5117C55.5378 50.0372 55.9225 49.6523 56.3972 49.6523H59.2366C59.7113 49.6523 60.096 50.0372 60.096 50.5117C60.096 50.9863 59.7111 51.3711 59.2366 51.3711Z"
          fill="#FFA8CF"
        />
        <path
          d="M72.5286 30.9715V26.9792C72.5286 25.555 71.374 24.4004 69.9498 24.4004H22.9987C21.5746 24.4004 20.4199 25.5549 20.4199 26.9792V30.9715H72.5286Z"
          fill="#6583FE"
        />
        <path
          d="M20.4199 56.3008V60.5956C20.4199 62.0197 21.5746 63.1744 22.9987 63.1744H69.9498C71.374 63.1744 72.5286 62.0199 72.5286 60.5956V56.3008H20.4199Z"
          fill="#B7C5FF"
        />
        <path
          d="M80.9525 73.0922H68.2305C67.2811 73.0922 66.5112 72.3225 66.5112 71.3729V47.4761C66.5112 46.5267 67.2809 45.7568 68.2305 45.7568H80.9525C81.9019 45.7568 82.6718 46.5265 82.6718 47.4761V71.3729C82.6718 72.3224 81.9021 73.0922 80.9525 73.0922Z"
          fill="#FF7EB8"
        />
        <path
          d="M66.5115 62.4385V71.3722C66.5115 72.3216 67.2811 73.0914 68.2306 73.0914H80.9526C81.902 73.0914 82.6718 72.3218 82.6718 71.3722V62.4385H66.5115Z"
          fill="white"
        />
        <path
          d="M77.8646 48.2007L78.6605 45.7568H70.5229L71.3189 48.2007C71.4342 48.5546 71.7641 48.7942 72.1362 48.7942H77.0472C77.4194 48.7942 77.7493 48.5546 77.8646 48.2007Z"
          fill="#B7C5FF"
        />
        <path
          d="M30.0847 73.0916H7.04739C6.09795 73.0916 5.32812 72.3219 5.32812 71.3723V42.3179C5.32812 41.3685 6.09778 40.5986 7.04739 40.5986H30.0847C31.0341 40.5986 31.8039 41.3683 31.8039 42.3179V71.3723C31.8038 72.3218 31.0341 73.0916 30.0847 73.0916Z"
          fill="white"
        />
        <path
          d="M31.8037 46.2148V42.3179C31.8037 41.3685 31.0341 40.5986 30.0845 40.5986H7.04739C6.09795 40.5986 5.32812 41.3683 5.32812 42.3179V46.2148H31.8037Z"
          fill="#02FFB3"
        />
        <path
          d="M15.2144 69.6289H9.88623C9.60143 69.6289 9.37061 69.3981 9.37061 69.1133V50.6367C9.37061 50.3519 9.60143 50.1211 9.88623 50.1211H15.2144C15.4992 50.1211 15.73 50.3519 15.73 50.6367V69.1133C15.73 69.3981 15.4992 69.6289 15.2144 69.6289Z"
          fill="#FFA8CF"
        />
        <path
          d="M27.2456 56.4805H18.6519C18.3671 56.4805 18.1362 56.2496 18.1362 55.9648V50.6367C18.1362 50.3519 18.3671 50.1211 18.6519 50.1211H27.2456C27.5304 50.1211 27.7612 50.3519 27.7612 50.6367V55.9648C27.7612 56.2496 27.5304 56.4805 27.2456 56.4805Z"
          fill="#FFA8CF"
        />
        <path
          d="M27.2456 69.6291H18.6519C18.3671 69.6291 18.1362 69.3982 18.1362 69.1134V59.3936C18.1362 59.1088 18.3671 58.8779 18.6519 58.8779H27.2456C27.5304 58.8779 27.7612 59.1088 27.7612 59.3936V69.1134C27.7612 69.3982 27.5304 69.6291 27.2456 69.6291Z"
          fill="#FFA8CF"
        />
        <path
          d="M25.6145 26.8164C25.1398 26.8164 24.7551 27.2012 24.7551 27.6758V27.6955C24.7551 28.1701 25.1398 28.5549 25.6145 28.5549C26.0892 28.5549 26.4739 28.1701 26.4739 27.6955V27.6758C26.4739 27.2012 26.0892 26.8164 25.6145 26.8164Z"
          fill="#2626BC"
        />
        <path
          d="M28.2507 26.8164C27.776 26.8164 27.3914 27.2012 27.3914 27.6758V27.6955C27.3914 28.1701 27.776 28.5549 28.2507 28.5549C28.7255 28.5549 29.1101 28.1701 29.1101 27.6955V27.6758C29.1101 27.2012 28.7255 26.8164 28.2507 26.8164Z"
          fill="#2626BC"
        />
        <path
          d="M30.8867 26.8164C30.412 26.8164 30.0273 27.2012 30.0273 27.6758V27.6955C30.0273 28.1701 30.412 28.5549 30.8867 28.5549C31.3614 28.5549 31.7461 28.1701 31.7461 27.6955V27.6758C31.7461 27.2012 31.3614 26.8164 30.8867 26.8164Z"
          fill="#2626BC"
        />
        <path
          d="M80.9526 44.8972H73.3879V26.9792C73.3879 25.0834 71.8455 23.541 69.9497 23.541H22.9986C21.1028 23.541 19.5604 25.0834 19.5604 26.9792V35.8655C19.5604 36.34 19.9451 36.7249 20.4198 36.7249C20.8945 36.7249 21.2792 36.34 21.2792 35.8655V31.8309H71.6691V44.8972H68.2306C66.8088 44.8972 65.652 46.0539 65.652 47.4758V51.5675C65.652 52.042 66.0366 52.4269 66.5113 52.4269C66.986 52.4269 67.3707 52.042 67.3707 51.5675V47.4758C67.3707 47.0016 67.7564 46.6159 68.2306 46.6159H69.899L70.5016 48.4667C70.7329 49.1764 71.3897 49.6533 72.1361 49.6533H77.0471C77.7935 49.6533 78.4503 49.1765 78.6816 48.4667L79.2842 46.6161H80.9526C81.4268 46.6161 81.8125 47.0018 81.8125 47.476V71.3728C81.8125 71.8468 81.4268 72.2325 80.9526 72.2325H68.2306C67.7564 72.2325 67.3707 71.8468 67.3707 71.3728V56.3013C67.3707 55.8267 66.986 55.4419 66.5113 55.4419H32.6631V42.3184C32.6631 40.8966 31.5064 39.7399 30.0845 39.7399H7.04739C5.62564 39.7399 4.46875 40.8966 4.46875 42.3184V71.3728C4.46875 72.7946 5.62547 73.9513 7.04739 73.9513H30.0845C31.5062 73.9513 32.6631 72.7946 32.6631 71.3728V64.0343H40.1373L38.0684 72.2327H36.1161C35.6414 72.2327 35.2567 72.6175 35.2567 73.0921C35.2567 73.5666 35.6414 73.9515 36.1161 73.9515H56.8324C57.3071 73.9515 57.6917 73.5666 57.6917 73.0921C57.6917 72.6175 57.3071 72.2327 56.8324 72.2327H54.88L52.8113 64.0343H65.6521V71.3728C65.6521 72.7946 66.8088 73.9513 68.2308 73.9513H80.9528C82.3745 73.9513 83.5314 72.7946 83.5314 71.3728V47.4758C83.5312 46.0541 82.3745 44.8972 80.9526 44.8972ZM21.2793 30.1121V26.9792C21.2793 26.0311 22.0505 25.2598 22.9988 25.2598H69.9499C70.8981 25.2598 71.6693 26.0311 71.6693 26.9792V30.1121H21.2793ZM77.0471 47.9346H72.1358L71.7064 46.6161H77.4766L77.0471 47.9346ZM7.04739 41.4583H30.0845C30.5587 41.4583 30.9444 41.844 30.9444 42.318V45.3556H6.1875V42.318C6.1875 41.844 6.57319 41.4583 7.04739 41.4583ZM30.9444 71.3726C30.9444 71.8467 30.5587 72.2324 30.0845 72.2324H7.04739C6.57319 72.2324 6.1875 71.8467 6.1875 71.3726V47.0745H30.9444V71.3726ZM53.1075 72.2325H39.841L41.9097 64.0341H51.0388L53.1075 72.2325ZM32.6631 62.3153V57.1605H65.6521V62.3153H32.6631Z"
          fill="#2626BC"
        />
        <path
          d="M9.82666 44.2766C10.3014 44.2766 10.686 43.8918 10.686 43.4172V43.3975C10.686 42.9229 10.3014 42.5381 9.82666 42.5381C9.35194 42.5381 8.96729 42.9229 8.96729 43.3975V43.4172C8.96729 43.8918 9.35194 44.2766 9.82666 44.2766Z"
          fill="#2626BC"
        />
        <path
          d="M12.4629 44.2766C12.9376 44.2766 13.3223 43.8918 13.3223 43.4172V43.3975C13.3223 42.9229 12.9376 42.5381 12.4629 42.5381C11.9882 42.5381 11.6035 42.9229 11.6035 43.3975V43.4172C11.6035 43.8918 11.9882 44.2766 12.4629 44.2766Z"
          fill="#2626BC"
        />
        <path
          d="M15.0989 44.2766C15.5736 44.2766 15.9583 43.8918 15.9583 43.4172V43.3975C15.9583 42.9229 15.5736 42.5381 15.0989 42.5381C14.6242 42.5381 14.2395 42.9229 14.2395 43.3975V43.4172C14.2395 43.8918 14.6242 44.2766 15.0989 44.2766Z"
          fill="#2626BC"
        />
        <path
          d="M46.0792 36.9785L46.4744 36.5835L46.8695 36.9785C47.0374 37.1462 47.2573 37.2301 47.4771 37.2301C47.6969 37.2301 47.9171 37.1462 48.0848 36.9783C48.4203 36.6426 48.4203 36.0986 48.0847 35.763L47.0819 34.7604C46.7466 34.4249 46.2021 34.4249 45.8668 34.7604L44.8641 35.763C44.5284 36.0986 44.5284 36.6426 44.8639 36.9783C45.1996 37.3141 45.7439 37.3141 46.0792 36.9785Z"
          fill="#2626BC"
        />
        <path
          d="M72.875 69.0846H70.4688C70.184 69.0846 69.9531 68.8537 69.9531 68.569V53.8164C69.9531 53.5316 70.184 53.3008 70.4688 53.3008H72.875C73.1598 53.3008 73.3906 53.5316 73.3906 53.8164V68.569C73.3906 68.8537 73.1598 69.0846 72.875 69.0846Z"
          fill="#97FFD2"
        />
        <path
          d="M68.3884 19.5479C67.9137 19.5479 67.5291 19.163 67.5291 18.6885C67.5291 18.1197 67.0665 17.6572 66.4978 17.6572C66.0231 17.6572 65.6384 17.2724 65.6384 16.7979C65.6384 16.3233 66.0231 15.9385 66.4978 15.9385C67.0665 15.9385 67.5291 15.476 67.5291 14.9072C67.5291 14.4327 67.9137 14.0479 68.3884 14.0479C68.8631 14.0479 69.2478 14.4327 69.2478 14.9072C69.2478 15.476 69.7103 15.9385 70.2791 15.9385C70.7538 15.9385 71.1384 16.3233 71.1384 16.7979C71.1384 17.2724 70.7538 17.6572 70.2791 17.6572C69.7103 17.6572 69.2478 18.1197 69.2478 18.6885C69.2478 19.1632 68.863 19.5479 68.3884 19.5479Z"
          fill="#97FFD2"
        />
        <path
          d="M78.6606 41.8252C78.1859 41.8252 77.8012 41.4404 77.8012 40.9658C77.8012 40.3971 77.3385 39.9346 76.7698 39.9346C76.2951 39.9346 75.9104 39.5497 75.9104 39.0752C75.9104 38.6006 76.2951 38.2158 76.7698 38.2158C77.3385 38.2158 77.8012 37.7533 77.8012 37.1846C77.8012 36.71 78.1859 36.3252 78.6606 36.3252C79.1353 36.3252 79.5199 36.71 79.5199 37.1846C79.5199 37.7533 79.9825 38.2158 80.551 38.2158C81.0257 38.2158 81.4104 38.6006 81.4104 39.0752C81.4104 39.5497 81.0257 39.9346 80.551 39.9346C79.9825 39.9346 79.5199 40.3971 79.5199 40.9658C79.5199 41.4404 79.1353 41.8252 78.6606 41.8252Z"
          fill="#6583FE"
        />
        <path
          d="M76.2541 23.3592C76.0343 23.3592 75.8141 23.2753 75.6465 23.1076L73.7559 21.217C73.4202 20.8813 73.4202 20.3371 73.7559 20.0016L75.6465 18.111C75.9819 17.7755 76.5264 17.7755 76.8617 18.111L78.7523 20.0016C79.088 20.3373 79.088 20.8815 78.7523 21.217L76.8617 23.1076C76.6941 23.2753 76.4739 23.3592 76.2541 23.3592ZM75.5788 20.6092L76.2541 21.2845L76.9294 20.6092L76.2541 19.9339L75.5788 20.6092Z"
          fill="#FF7EB8"
        />
        <path
          d="M12.5505 35.8074C12.3307 35.8074 12.1105 35.7236 11.9429 35.5558L10.0523 33.6652C9.71662 33.3295 9.71662 32.7854 10.0523 32.4499L11.9429 30.5592C12.2782 30.2237 12.8227 30.2237 13.1581 30.5592L15.0487 32.4499C15.3844 32.7855 15.3844 33.3297 15.0487 33.6652L13.1581 35.5558C12.9903 35.7236 12.7703 35.8074 12.5505 35.8074ZM11.8752 33.0574L12.5505 33.7327L13.2258 33.0574L12.5505 32.3821L11.8752 33.0574Z"
          fill="#FF7EB8"
        />
        <path
          d="M62.4478 39.6348C62.9784 39.6348 63.4086 40.065 63.4086 40.5955C63.4086 41.1261 62.9784 41.5563 62.4478 41.5563C61.9173 41.5563 61.4871 41.1261 61.4871 40.5955C61.4871 40.065 61.9173 39.6348 62.4478 39.6348Z"
          fill="#FF5BA8"
        />
        <path
          d="M62.4478 36.7285C62.9784 36.7285 63.4086 37.1587 63.4086 37.6893C63.4086 38.2199 62.9784 38.6501 62.4478 38.6501C61.9173 38.6501 61.4871 38.2199 61.4871 37.6893C61.4871 37.1587 61.9173 36.7285 62.4478 36.7285Z"
          fill="#FF5BA8"
        />
        <path
          d="M62.4478 33.8223C62.9784 33.8223 63.4086 34.2525 63.4086 34.783C63.4086 35.3136 62.9784 35.7438 62.4478 35.7438C61.9173 35.7438 61.4871 35.3136 61.4871 34.783C61.4871 34.2525 61.9173 33.8223 62.4478 33.8223Z"
          fill="#FF5BA8"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2042_6647"
          x1="-5.36355"
          y1="46.1695"
          x2="90.3638"
          y2="49.9648"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0485" stopColor="#FFDBED" />
          <stop offset="0.9993" stopColor="#D2DEFF" />
        </linearGradient>
        <clipPath id="clip0_2042_6647">
          <rect width="88" height="88" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IllustrationDevices;
